var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _linearGradient22, _linearGradient23, _linearGradient24, _linearGradient25, _linearGradient26, _linearGradient27, _linearGradient28, _linearGradient29, _linearGradient30, _linearGradient31, _linearGradient32, _linearGradient33, _linearGradient34, _linearGradient35, _linearGradient36, _linearGradient37, _linearGradient38, _linearGradient39, _linearGradient40, _linearGradient41, _linearGradient42, _linearGradient43, _linearGradient44, _linearGradient45, _linearGradient46, _linearGradient47, _linearGradient48, _linearGradient49, _linearGradient50, _linearGradient51, _linearGradient52, _linearGradient53, _style, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrameBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 345.6,
    height: 424.834,
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 9245.62 11365.26",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "id29",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#id2",
    x1: 3235.35,
    y1: -1062.53,
    x2: 4943.52,
    y2: 10134.27
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "id58",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#id1",
    x1: 2358.05,
    y1: 9466.37,
    x2: -3948.46,
    y2: 11357.66
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "id1",
    gradientUnits: "userSpaceOnUse",
    x1: 2360.73,
    y1: 9551.97,
    x2: -3980.49,
    y2: 11289.81
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopOpacity: 1,
      stopColor: "#77a81a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopOpacity: 1,
      stopColor: "#c8ff31"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "id2",
    gradientUnits: "userSpaceOnUse",
    x1: 3457.2,
    y1: -155.01,
    x2: 5164.91,
    y2: 9351.83
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopOpacity: 1,
      stopColor: "#924a23"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopOpacity: 1,
      stopColor: "#733c1f"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "id3",
    gradientUnits: "userSpaceOnUse",
    x1: 3406.95,
    y1: 646.9,
    x2: 3780.48,
    y2: 5362.53
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopOpacity: 1,
      stopColor: "#ce9549"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopOpacity: 1,
      stopColor: "#bc6f3b"
    }
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "id4",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#id2",
    x1: 3562.55,
    y1: -1104.77,
    x2: 5270.44,
    y2: 9979.34
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "id5",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#id3",
    x1: 2189.85,
    y1: 632.14,
    x2: 2566.25,
    y2: 5334.27
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "id6",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#id2",
    x1: 3737.19,
    y1: -1284.92,
    x2: 5446.55,
    y2: 10090.94
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "id7",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#id3",
    x1: 7675.34,
    y1: 199.15,
    x2: 8036.61,
    y2: 4883.76
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "id8",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#id2",
    x1: 2238.78,
    y1: -929.73,
    x2: 3926.7,
    y2: 10078.8
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "id9",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#id3",
    x1: 4120.32,
    y1: 413.17,
    x2: 4499.89,
    y2: 5286.85
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "id10",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#id3",
    x1: 7326.9,
    y1: 194.73,
    x2: 7697.74,
    y2: 5000.02
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "id11",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#id3",
    x1: 3962.3,
    y1: 625.31,
    x2: 4341.95,
    y2: 5365.52
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "id12",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#id3",
    x1: 3284.04,
    y1: 812.28,
    x2: 3659.86,
    y2: 5574.7
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "id13",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#id3",
    x1: 3620.1,
    y1: 1079.38,
    x2: 3998.78,
    y2: 5697.35
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "id14",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#id2",
    x1: 3275.37,
    y1: -1125.19,
    x2: 4983.59,
    y2: 10147.21
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "id15",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#id3",
    x1: 4159.85,
    y1: 593.16,
    x2: 4539.69,
    y2: 5242.59
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "id16",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#id2",
    x1: 3691.23,
    y1: -1313.23,
    x2: 5398.73,
    y2: 10139.73
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "id17",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#id3",
    x1: 2924.21,
    y1: 644.7,
    x2: 3299.73,
    y2: 5134.41
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "id18",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#id3",
    x1: 4245.06,
    y1: 609.09,
    x2: 4624.9,
    y2: 5192.44
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "id19",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#id2",
    x1: 2944.53,
    y1: -993.54,
    x2: 4629.87,
    y2: 9840.43
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "id20",
    gradientUnits: "userSpaceOnUse",
    x1: -524.64,
    y1: 9938.49,
    x2: 2148.56,
    y2: 10021.85
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopOpacity: 1,
      stopColor: "#bff233"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopOpacity: 1,
      stopColor: "#8eca37"
    }
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "id21",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#id2",
    x1: 3041.74,
    y1: -469,
    x2: 4749.12,
    y2: 10100.96
  })), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "id22",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#id2",
    x1: 2995.7,
    y1: -945.63,
    x2: 4703.44,
    y2: 10218.15
  })), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "id23",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#id3",
    x1: 3843.35,
    y1: 868.24,
    x2: 4222.88,
    y2: 5486.22
  })), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "id24",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#id3",
    x1: 6793.02,
    y1: 134.04,
    x2: 7163.51,
    y2: 5084.44
  })), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "id25",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#id1",
    x1: 2346.39,
    y1: 9435.22,
    x2: -3982.31,
    y2: 11369.18
  })), _linearGradient24 || (_linearGradient24 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "id26",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#id2",
    x1: 3512.32,
    y1: -912.03,
    x2: 5220.2,
    y2: 9854.06
  })), _linearGradient25 || (_linearGradient25 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "id27",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#id20",
    x1: 8680.18,
    y1: 307.68,
    x2: 7622.53,
    y2: 2660.19
  })), _linearGradient26 || (_linearGradient26 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "id28",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#id3",
    x1: 7086.98,
    y1: 267.92,
    x2: 7452.17,
    y2: 5068.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "id0",
    gradientUnits: "userSpaceOnUse",
    x1: 4455.54,
    y1: 2806.68,
    x2: 4455.54,
    y2: 15421.37
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopOpacity: 1,
      stopColor: "#683119"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.722,
    style: {
      stopOpacity: 1,
      stopColor: "#7e4020"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopOpacity: 1,
      stopColor: "#944f28"
    }
  })), _linearGradient27 || (_linearGradient27 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "id30",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#id2",
    x1: 3184.29,
    y1: -1230.39,
    x2: 4892.56,
    y2: 10227.77
  })), _linearGradient28 || (_linearGradient28 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "id31",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#id2",
    x1: 4056.86,
    y1: -1363.64,
    x2: 5756.73,
    y2: 10072.89
  })), _linearGradient29 || (_linearGradient29 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "id32",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#id2",
    x1: 3825.77,
    y1: -1165.02,
    x2: 5534.36,
    y2: 9903.87
  })), _linearGradient30 || (_linearGradient30 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "id33",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#id3",
    x1: 4289.79,
    y1: 454.36,
    x2: 4669.51,
    y2: 5236.46
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "id34",
    gradientUnits: "userSpaceOnUse",
    x1: 4440.28,
    y1: 1998.62,
    x2: 4661.82,
    y2: 9190.21
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopOpacity: 1,
      stopColor: "#95502b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopOpacity: 1,
      stopColor: "#81411f"
    }
  })), _linearGradient31 || (_linearGradient31 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "id35",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#id3",
    x1: 4060.6,
    y1: 714.9,
    x2: 4440.18,
    y2: 5293.52
  })), _linearGradient32 || (_linearGradient32 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "id36",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#id3",
    x1: 4416.6,
    y1: 375.4,
    x2: 4796.18,
    y2: 5157.14
  })), _linearGradient33 || (_linearGradient33 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "id37",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#id1",
    x1: 2351.77,
    y1: 9581.13,
    x2: -3979.64,
    y2: 11112.83
  })), _linearGradient34 || (_linearGradient34 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "id38",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#id3",
    x1: 3765.06,
    y1: 516.07,
    x2: 4144.74,
    y2: 5399.43
  })), _linearGradient35 || (_linearGradient35 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "id39",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#id2",
    x1: 3098.2,
    y1: -1212.52,
    x2: 4805.83,
    y2: 10241.49
  })), _linearGradient36 || (_linearGradient36 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "id40",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#id3",
    x1: 3845.46,
    y1: 701.1,
    x2: 4225.15,
    y2: 5461.53
  })), _linearGradient37 || (_linearGradient37 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "id41",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#id3",
    x1: 3205.15,
    y1: 906.17,
    x2: 3578.36,
    y2: 5587.98
  })), _linearGradient38 || (_linearGradient38 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "id42",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#id2",
    x1: 802.48,
    y1: -822.86,
    x2: 2364.47,
    y2: 10640.47
  })), _linearGradient39 || (_linearGradient39 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "id43",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#id3",
    x1: 4099.29,
    y1: 462.13,
    x2: 4478.89,
    y2: 5285.79
  })), _linearGradient40 || (_linearGradient40 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "id44",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#id3",
    x1: 3958.08,
    y1: 675.39,
    x2: 4337.73,
    y2: 5414.01
  })), _linearGradient41 || (_linearGradient41 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "id45",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#id3",
    x1: 994.71,
    y1: 769.16,
    x2: 1365.43,
    y2: 5608.21
  })), _linearGradient42 || (_linearGradient42 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "id46",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#id1",
    x1: 2296.11,
    y1: 9424.44,
    x2: -3878.7,
    y2: 11315.13
  })), _linearGradient43 || (_linearGradient43 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "id47",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#id3",
    x1: 4013.06,
    y1: 1019.4,
    x2: 4392.72,
    y2: 5367.21
  })), _linearGradient44 || (_linearGradient44 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "id48",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#id3",
    x1: 6760.77,
    y1: 168.47,
    x2: 7132.57,
    y2: 5056
  })), _linearGradient45 || (_linearGradient45 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "id49",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#id3",
    x1: 4393.34,
    y1: 802.25,
    x2: 4772.85,
    y2: 4314.62
  })), _linearGradient46 || (_linearGradient46 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "id50",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#id0",
    x1: 4819.5,
    y1: 10220.58,
    x2: 4464.67,
    y2: 4489.11
  })), _linearGradient47 || (_linearGradient47 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "id51",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#id1",
    x1: 6481.19,
    y1: 3114.75,
    x2: 12109.62,
    y2: -2621.55
  })), _linearGradient48 || (_linearGradient48 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "id52",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#id3",
    x1: 6903.84,
    y1: 318.14,
    x2: 7277.15,
    y2: 5129.62
  })), _linearGradient49 || (_linearGradient49 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "id53",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#id2",
    x1: 5918.78,
    y1: -1597.33,
    x2: 7572.07,
    y2: 9659.21
  })), _linearGradient50 || (_linearGradient50 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "id54",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#id2",
    x1: 2768.75,
    y1: -832.84,
    x2: 4442.31,
    y2: 10272.2
  })), _linearGradient51 || (_linearGradient51 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "id55",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#id3",
    x1: 4113.76,
    y1: 1565.67,
    x2: 5465,
    y2: 13426.32
  })), _linearGradient52 || (_linearGradient52 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "id56",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#id2",
    x1: 3205.6,
    y1: -868.02,
    x2: 4881.36,
    y2: 9959.37
  })), _linearGradient53 || (_linearGradient53 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "id57",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#id3",
    x1: 5027.16,
    y1: 301.64,
    x2: 5405.57,
    y2: 5223.94
  })), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".fil3{fill:#648929;fill-rule:nonzero}"))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_1882457327920"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8612.33 0c-104.46 318.52-338.84 499.92-576.32 678.12 288.81-7.42 577.62-14.83 866.42-22.26-69.5 171.46-224.43 301.2-398.45 333.66 247.2 93.88 494.43 187.8 741.64 281.69-192.38 94.12-384.68 188.27-577.04 282.39 304.55 335.64 495.82 783.45 532.42 1246.49-243.9-49.18-487.77-98.47-731.68-147.65-226.42-45.76-468.98-100.58-625.61-279.11-179.9-205.03-207.79-533.66-416.6-705.64-167.24-137.66-596.85-158.6-628.17-436.06-24.4-216.92-76.83-392.54 34.33-541.62C7193.46 207.12 8499.42 84.77 8612.33.02z",
    style: {
      fill: "url(#id27)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8073.42 2671.43c-.44 8.32-.44 16.68-.93 25.52-.9 32.81-2.34 68.14-3.7 105.37-143.99-6.39-292.11-18.66-404.08-74.01-46.45-23.04-21.84-79.39 35.75-85.31 128.68-13.26 248.5 10.81 372.96 28.43z",
    style: {
      fill: "url(#id7)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8081.6 372.22c-80.37 245-260.71 384.6-443.4 521.62 222.18-5.67 688.93-89.33 911.11-95.04-53.48 131.88-502.13 220.05-635.98 245.05 190.18 72.22 725.8 158.94 915.93 231.2-147.93 72.39-556.44 219.88-704.43 292.31 366.61 118.53 818.6 602.68 846.75 958.89-187.62-37.82-812.38-75.68-1000-113.6-174.18-35.13-360.83-77.37-481.26-214.69-138.4-157.73-159.89-410.55-320.49-542.82-128.64-105.93-459.19-122.05-483.21-335.5-18.84-166.86-59.18-301.96 26.35-416.64 277.09-371.48 1281.76-465.61 1368.64-530.79z",
    style: {
      fill: "url(#id51)"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "fil3",
    d: "M8671.5 742.02c-530.56 172.53-1052.54 253.07-1608.52 203.71-46.68-4.17-50.52 73.64-3.5 76.9 545.65 38.09 1111.92-36.71 1621-253.76 14.19-6.05 5.81-31.66-8.99-26.85zM8920.66 1273.94c-292.76 14.63-557.9.29-846.58-58.76-19.48-4.03-27.37 24.91-8.21 31.57 268.71 93.5 581.28 114.72 857.59 48.93 11.44-2.75 9.03-22.3-2.8-21.74zM9074.56 2627.05c-138.37-276.33-415.43-579.01-714.44-644.98-49.46-10.93-86.83 64.47-36.32 90.92 127.06 66.69 257 118.54 378.69 197.75 153 99.57 250.29 215.29 356.76 365.74 6.68 9.42 20.76 1.46 15.31-9.43z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M633.27 11365.26c104.44-318.51 338.83-499.92 576.3-678.09-288.79 7.4-577.58 14.81-866.37 22.3 69.5-171.46 224.46-301.25 398.41-333.66-247.2-93.92-494.4-187.79-741.61-281.74 192.34-94.12 384.68-188.26 577.01-282.39C272.5 9476.04 81.22 9028.27 44.59 8565.19c243.9 49.23 487.81 98.46 731.67 147.7 226.43 45.72 469.06 100.56 625.62 279.06 179.89 205.08 207.83 533.69 416.6 705.64 167.24 137.67 596.85 158.64 628.16 436.06 24.41 216.93 76.87 392.54-34.32 541.6-360.16 482.92-1666.15 605.27-1779.05 690z",
    style: {
      fill: "url(#id20)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1164.02 10993.06c80.37-245 260.67-384.6 443.37-521.61-222.2 5.68-688.9 89.31-911.09 95.02 53.44-131.88 502.09-220.06 635.94-245.05-190.13-72.21-725.75-158.93-915.92-231.2 147.97-72.4 556.47-219.93 704.43-292.3-366.62-118.54-818.61-602.69-846.75-958.9 187.61 37.83 812.38 75.73 1000.03 113.59 174.15 35.19 360.81 77.39 481.27 214.71 138.4 157.77 159.88 410.55 320.52 542.85 128.6 105.89 459.16 122.06 483.18 335.47 18.79 166.86 59.18 301.95-26.39 416.64-277.05 371.47-1281.72 465.64-1368.6 530.79z",
    style: {
      fill: "url(#id25)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M951.1 11159.62c453.25-338.36 925.44-586.49 1468.38-722.33 45.55-11.41 26.23-86.54-19.4-74.23-529.71 143.2-1045.74 400.38-1465.48 774.02-11.67 10.41 3.86 31.97 16.5 22.54z",
    style: {
      fill: "url(#id58)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.12 10623.25c530.56-172.49 1052.55-253.06 1608.52-203.71 46.66 4.16 50.47-73.63 3.46-76.9-545.61-38.12-1111.87 36.71-1620.99 253.77-14.2 6.05-5.78 31.65 9.02 26.83z",
    style: {
      fill: "url(#id1)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.97 10091.34c292.76-14.63 557.93-.27 846.53 58.79 19.57 3.99 27.42-24.96 8.25-31.6-268.71-93.5-581.27-114.72-857.58-48.93-11.48 2.72-9.07 22.3 2.8 21.74z",
    style: {
      fill: "url(#id37)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.07 8738.28c138.37 276.32 415.37 578.96 714.44 644.92 49.41 10.94 86.78-64.41 36.31-90.91-127.05-66.69-257.03-118.54-378.72-197.71-153.01-99.62-250.21-215.34-356.69-365.77-6.76-9.43-20.83-1.47-15.34 9.47z",
    style: {
      fill: "url(#id46)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8104.5 7431.11c-42.62 565.28-839.95 787.46-751.53 805.01 194.61 38.56 286.45-58.92 411.47-31.2 173.51 38.51 266.11 212.15 241.42 479.11-79.1 856.27-37.5 1182.85-59.01 1342.87-144.02 1070.7-1071.28 566.48-6012.95 708.52-739.16 21.24-458.34-500.1-420.83-565.71-399.15-7.55-477.89-44.53-557.28-158.87-53.48-77.01-65.96-249.24-70.81-342.7-41.39-800.63-123.44-1470.48-145.72-2271.94-3.01-108.97 55.39-168.45 58.28-171.32 431.49-430.29 825.97-382.89 1146.52-351.54-311-162.96-847.63 54.08-1123.82-56.57-56.54-22.63-92.81-80.02-96.03-142.37-37.26-721-74.52-1441.96-112.21-2163.01-1.91-36.57 5.01-73.03 19.76-106.44 118.68-269.54 392.16-534.31 444.38-618.68-172.12 10.77-320.01-8.75-431.73-76.72-48.56-29.54-78.01-83.88-81.01-141.87-11.18-216.96-22.45-433.57-33.68-650.58-6.42-121.71-10.98-248.14-8.22-373.28.74-34.69 10.41-68.83 28.93-97.77 83.73-130.89 241.06-251.75 342.9-321.47 25.13-17.2 14.24-57.34-15.9-58.41-52.76-1.88-106.4-11.88-116.65-44.82-19.11-61.19-4.74-128.65 32.35-180.38 23.95-33.41 50.59-65.22 79.95-95.07 228.78-231.76 614.8-397.12 933.9-438.51 1876.26-244.19 3442.48-258.22 5325.57-73.3 185.5 18.4 122.3-46.36 304.26-11.54 844.55 161.64 840.48 478.09 811.81 2061.32-24.81 1372.15-71.14 3178.77-144.1 4147.27z",
    style: {
      fill: "url(#id50)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8083.1 2391.76c-.49 7.81-4.19 119.1-10.7 303.89-9.76 277.4-24.61 721-41.77 1230.27-1.38 37.75-2.84 75.49-4.23 113.69-1.39 36.8-2.28 73.57-3.7 110.79-1.88 51.51-3.26 103.91-5.58 156.36-12.03 372.04-25.53 764.15-37.61 1142.1-1.39 29.86-2.32 59.31-3.26 89.17-2.32 67.66-4.63 135.31-6.46 201.95-1.87 50.95-3.75 101.47-5.14 151.47-16.27 488.68-30.67 926.85-40.41 1232.25-.94 39.19-2.33 76.46-3.26 111.24 0 6.86-.44 13.76-.9 20.58-2.8 63.73-12.08 127.42-27.41 189.74-76.67 305.36-209.46 582.74-462.6 735.2 128.16 16.17 228.49 7.85 312.11 19.59 83.14 11.82 144.47 88.27 141.22 176.43-8.38 222.61-17.2 428.45-26.04 615.17v.52c-4.19 80.37-7.89 157.35-11.59 229.87-22.33 399.97-45.51 676.88-72.03 771.99-223.37 802.36-961.34 345.07-5687.57 450.45-181.61 4.4-378.04-6.88-547.57-70.57-59.46-22.6-96.19-85.34-87.8-151.5v-1.46c12.57-104.4 137.03-57.35 219.7-125.92-121.24-29.45-242-58.85-363.19-88.26-104.98-25.51-186.29-115.15-203-227.89-13.46-91.69-19.04-186.3-23.67-278.47-39.48-787.18-55.27-1469.45-94.72-2256.62-2.85-57.86 53.37-165.66 55.72-168.58 175.54-209.32 460.72-250.49 718.95-183.38 26.47 6.86 46.44-27.93 25.99-47.52-173.25-168.63-512.25-86.76-747.29-189.17-63.62-27.97-106.32-92.64-110.07-165.71-6.02-118.12-11.59-235.74-17.6-353.86-1.43-29.93-2.84-59.83-4.68-89.72-.44-5.87-.44-11.79-.93-17.62-24.17-484.28-48.73-969.06-73.37-1453.33-1.87-39.2-3.75-77.92-6.03-117.16-1.39-31.35-3.25-63.21-4.68-94.61-1.83-36.24 5.09-72.01 19.04-104.86 113.31-265.21 374.83-525.43 424.98-608.29-164.44 10.77-306.06-8.84-412.41-75.48-46.9-28.91-75.24-82.34-78.06-139.69-10.65-213.22-21.34-426.41-32-639.65-6.07-120.07-10.7-244.57-7.93-368.09.93-33.84 10.21-67.16 27.87-95.59 116.55-186.77 308.41-204.87 359.98-389.19 6.02-23.04-15.81-43.14-37.17-35.78-39.02 13.73-70.62 18.61-95.67 16.17-52.5-3.93-78.94-37.26-90.62-80.88-15.73-59.79-.89-124.49 33.93-173.98 22.77-32.39 47.82-62.74 75.24-91.65 218.77-227.95 545.23-286.27 850.4-326.92 1794.15-240.2 3613.87-270.1 5414.51-88.27 105.42 10.77 213.66 23.55 314.88 53.91 69.67 20.59 135.64 50.01 195.55 93.15 111.44 80.36 184.37 192.6 230.36 322.03 82.2 228.41 81.76 510.22 68.29 761.7z",
    style: {
      fill: "url(#id55)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8014.89 1630.14c-366.45-240.62-797.93-288.19-1243.77-331.81-668.81-64.71-1340.9-100.01-2012.48-105.88-671.56-5.87-1343.17 17.66-2012.91 70.12-342.74 26.45-692.46 47.05-1031.99 107.3-306.54 53.95-636.75 190.68-719.41 540.66-.96 4.42-2.35 8.32-3.73 12.27-52.47-3.95-78.95-37.28-90.59-80.88-15.77-59.84-.89-124.51 33.93-174 22.77-32.38 47.82-62.74 75.24-91.69 218.77-227.9 545.23-286.22 850.4-326.91 1794.15-240.17 3613.87-270.07 5414.51-88.23 177.41 18.14 362.72 41.18 510.43 147.07 111.44 80.36 184.37 192.6 230.36 321.98z",
    style: {
      fill: "#e8b667",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8053.9 1771.03c-313-9.83-625.13-31.86-936.34-56.35-705.01-56.39-1410-130.89-2122.97-126.48-727.32 4.43-1447.21 77.93-2173.57 92.16-329.8 6.35-660.01-2.95-986.01-35.8-287.54-28.91-567.12-71.54-847.14-43.14 6.46-8.32 13.86-16.17 21.31-24.02l.49-.48c182.05-50.94 390.13-74.01 592.14-91.17h.5c342.78 34.32 677.14 66.69 1026.42 66.69 727.78-.51 1445.83-87.27 2172.22-101.48 707.32-13.25 1406.35 52.46 2103.94 115.2 370.19 33.33 741.27 64.68 1114.64 79.86 13.94 40.23 25.54 81.87 34.37 125.01z",
    style: {
      fill: "url(#id36)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8082.74 1968.09c-186.72-35.8-378.09-62.26-570.82-81.38-1169.96-116.15-2347.32 45.58-3514.02 96.57-610.72 26.98-1209.41 4.88-1818.75-23.02-352.5-16.69-720.82-24.54-1068.24 18.6 4.63-11.27 8.87-23.03 12.57-35.3 6.02-23.02-15.81-43.14-37.17-35.76-39.02 13.72-70.62 18.61-95.67 16.17-15.33-.99-28.35-4.88-39.48-10.81 402.2-82.81 839.26-78.91 1275.38-52.45 373.4 22.55 742.62 50.52 1118.39 44.64 386.41-5.87 771.41-30.4 1155.06-60.29 1176.46-90.19 2405.35-217.64 3566.93-4.94 6.95 41.69 12.08 84.83 15.82 127.98z",
    style: {
      fill: "url(#id49)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2043.06 7470.52c-30.19 143.11-225.25 234.8-443.09 257.31-207.14 21.11-403.58-18.09-594.97-66.17-1.39-35.76-2.77-71.53-4.65-107.81 170.02 47.05 344.16 88.22 526.25 80.89 269.83-11.28 518.81-205.86 230.37-325.94-126.77-52.92-333.47-63.26-478.38-80.88-95.22-11.28-190.47-22.04-285.65-31.35 8.79-35.29 25.55-73.03 36.69-96.57 238.25 19.09 477.93 46.06 694.35 96.07 193.67 44.6 348.35 136.25 319.07 274.47z",
    style: {
      fill: "url(#id45)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8089.69 2226.4c-.93 39.19-2.37 77.93-4.2 116.14-230.36-8.32-459.78-26.94-687.39-48.97-675.76-64.26-1308.79-157.36-1998.95-126.48-415.67 18.61-825.8 61.76-1236.82 100.96 408.71 35.29 811.84 99.02 1199.2 178.91 554.5 114.73 1189.93 317.12 1171.78 737.7-16.22 388.67-639.51 527.41-1171.78 551.38-228.06 10.34-459.79-12.73-688.28-10.28-202.06 2.95-404.11 17.15-605.69 24.05-438.88 14.66-875.45 34.78-1315.31 38.21-529.9 3.9-1056.12 1.97-1581.87-15.18 36.24-43.14 65.98-78.92 84.51-104.43 549.48 20.12 1100.29 31.86 1649.28 23.55 438.88-6.35 878.26-14.24 1314.83-41.69 445.39-27.93 867.11-101.48 1299.99-167.14 313.98-47.55 796.06-157.34 720.38-412.17-79.43-266.67-523.9-399.53-888.96-491.18-707.36-176.48-1447.21-227.43-2199.16-242.62-552.24 9.31-1096.1-37.73-1652.03-53.94-235.94-6.83-478.39-4.37-713.88 17.67 48.77-66.19 107.29-109.33 163.05-150.02h.46c656.72-20.6 1351.06 73.55 2007.33 85.3 1177.81 21.1 2322.23-198 3503.32-123.52 541.11 34.32 1085.85 97.06 1630.21 113.74z",
    style: {
      fill: "url(#id33)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4036.49 3098.88c-34.4 143.1-254.53 235.23-501.2 257.32-384.55 34.31-736.11-92.64-1084.46-158.29-573.55-108.38-1135.1-125.49-1691.03-74.54-1.88-40.19-3.7-79.91-6.03-120.13 287.95-19.6 579.15-21.05 858.74-8.28 302.84 13.69 601.45 48.5 888.03 103.92 305.64 58.8 616.77 176.94 952.11 164.16 304.67-11.27 586.12-205.85 260.54-325.94-143.49-52.91-377.11-63.21-541.06-80.88-391.99-41.63-787.73-70.59-1186.19-86.75-412.93-16.63-829.04-20.11-1244.26-10.81-1.38-28.9-2.32-58.28-3.25-87.7 561.96-18.1 1125.37-8.84 1689.16 26.93 408.26 26.05 861.09 47.57 1248.45 126.52 218.25 44.6 393.38 136.22 360.43 274.48z",
    style: {
      fill: "url(#id5)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5446.54 3194.43c-182.09 176.48-577.33 247.53-884.33 297.02-1237.31 199.51-2513.13 1.03-3768.04 17.2-11.15-22.08-17.17-47.08-18.55-72.56-.98-18.14-1.87-36.28-2.8-54.38 478.37-9.35 960.5 12.21 1440.25 33.79 885.22 39.71 1849.41 87.74 2682.66-142.65 246.59-68.1 639.52-263.19 336.23-441.59-177.9-104.94-483.02-142.17-714.31-175.49-480.74-68.66-979.98-90.23-1471.38-106.4-773.72-25.96-1541.04-3.43-2310.62 25.52-.89-36.76-.89-73.55-.46-110.31 781.63-58.8 1579.6-56.82 2360.78-30.35 416.6 14.19 836.94 33.79 1248.91 79.38 332.52 36.74 765.88 82.84 1023.65 232.82 206.66 119.61 229.39 301.45 78.02 447.99z",
    style: {
      fill: "url(#id17)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6557.96 10481.51c-88.74-.48-183.95-1.93-286.58-3.9 94.74-67.17 104.98-135.73-82.23-185.27-232.64-61.23-622.31-56.85-918.2-57.38-614.02-.94-1249.34 36.29-1874.01 76.51-522.95 33.83-1043.14 77.42-1561.91 127.42h-.97c-102.12-9.78-202.45-28.95-295.36-63.73-1.87-.98-4.19-1.46-6.07-2.91 640.46-63.74 1284.21-113.23 1920.03-154.4 529.9-33.83 1064.54-64.25 1590.29-73.56 424.45-7.33 977.63-18.59 1314.34 68.67 223.86 57.8 289.34 161.21 200.68 268.54z",
    style: {
      fill: "url(#id12)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8075.74 2598.4c-575.41 0-1155.07-44.61-1722.16-110.26 344.16 129.91 692.52 257.79 1053.36 366.63 213.2 63.73 427.74 108.81 655.82 129.38-1.86 46.59-3.25 95.6-5.12 146.55-207.14-26.46-409.2-66.18-598.2-119.57-579.65-164.72-1117-399.48-1668.3-597.53-96.14-34.77-28.79-120.03 72.93-107.34 740.3 96.11 1465.32 208.86 2213.55 237.71-.49 17.2-.93 35.34-1.87 54.43z",
    style: {
      fill: "url(#id48)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8054.83 3207.17a68701.4 68701.4 0 0 0-4.14 126.93c-145.37-26.93-290.33-54.38-435.2-81.82-161.17-30.4-507.65-142.64-658.62-65.66-117.47 60.26-104.49 221.54-149.07 306.81-222.03 419.55-1071.01 428.39-1653.41 465.65-1403.58 91.17-2806.18 131.36-4213.01 116.19 23.72-36.8 48.28-72.57 73.42-106.87 1398.9-7.86 2798.73-93.14 4190.23-158.34 419.8-19.6 952.56-5.36 1270.21-207.81 219.26-139.69 130.1-367.11 350.21-497.5 222.03-131.86 600.07-10.76 841.13 32.39 129.58 23.47 259.16 47 388.25 70.04z",
    style: {
      fill: "url(#id18)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8045.07 3504.19c-1.39 32.89-2.76 66.18-3.7 100.01-140.72-44.08-283.77-85.26-439.33-101.94-213.66-23.02-443.12-.99-573.15 117.17-85 77.92-107.29 176.94-184.37 257.32-315.85 331.81-1176.47 272.49-1698.52 293.56-851.35 35.34-1701.74 75.01-2553.07 103.9-587.99 19.65-1179.64 49.54-1770.45 63.27 1.39-26.46 7.9-52.96 18.55-77.97 10.25-23.97 21.85-48.04 34.41-71.54 605.65-30.4 1215.47-44.6 1819.69-67.15 867.11-32.86 1735.65-55.88 2603.7-83.29 360.88-11.28 828.07 16.17 1158.77-91.18 307.44-99.03 290.27-337.73 550.81-462.23 313.04-150.02 688.32-83.84 1036.63 20.07z",
    style: {
      fill: "url(#id15)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8038.13 3705.2c-1.88 47.52-3.27 95.55-5.14 144.57-320.44-55.36-595.38-49.02-667.37 112.23-60.35 136.29-54.83 247.07-235.49 348.53-143.49 79.86-323.26 135.27-507.62 167.6-270.8 47.52-567.54 51.47-846.21 59.83-336.28 10.77-675.76 17.62-1011.59 10.29-706.87-15.69-1417.03 33.33-2123.46 45.54-76.63 1.03-72.88-67.62 0-72.52 764.02-50.99 1525.76-85.77 2286.01-151 347.43-29.86 700.82-51.42 1051.04-64.63 270.3-10.33 595.88 6.34 856.42-47.61 347.42-72.51 245.7-266.62 390.17-428.34 103.54-116.19 311.61-154.9 514.12-149.03 95.66 2.44 196.49 11.28 299.11 24.53z",
    style: {
      fill: "url(#id57)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8022.71 4150.4c-1.88 51.51-3.26 103.91-5.58 156.36-209.91 154.44-525.26 334.3-599.62 371.05-224.29 110.79-574.92 89.21-842.46 97.06-781.68 23.54-1563.83 41.69-2346.88 54.89-391.05 6.87-782.11 12.26-1173.65 13.25-300.94 1.47-591.69 12.27-848.08-98.03-159.31-68.62-280.03-124.02-472.81-149.5-164.4-21.05-320.9-37.27-489.53-37.27-137.91-.47-274.89 6.87-411.46 16.68-1.87-39.2-3.75-77.92-6.03-117.16 328.83-30.85 675.26-25.96 951.14 58.87 241.55 74.97 414.32 208.78 689.26 245.02 329.76 43.65 714.31-9.26 1046.83-21.58 679.51-25 1360.84-46.07 2041.22-59.26 339.53-6.4 679.99-10.78 1019.97-16.69 177.88-2.91 377.09 5.92 551.75-17.11 210.38-28.01 622.83-305.44 730.08-380.87 65.52-46.57 120.31-84.83 165.82-115.71z",
    style: {
      fill: "url(#id9)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8011.19 4486.45c-1.87 66.18-4.15 132.34-6.5 199.04-63.16 147.06-134.7 249.47-304.22 341.62-221.54 120.56-546.62 115.16-821.61 100.95-466.3-23.97-927.95-39.67-1396.58-33.32-489.07 6.87-975.34 24.05-1461.12 59.31-426.41 31.35-865.73 63.21-1293.97 29.89-379.46-28.91-672.06-143.1-1002.76-252.89-258.66-86.29-580.54-167.64-881.51-155.9-1.39-28.38-2.76-56.34-4.64-84.78 522.07 5.87 1040.84 307.83 1547.56 369.09 520.18 62.79 1021.29-17.63 1534.49-59.79 500.22-41.16 1007.43-65.19 1511.8-66.18 495.08-.98 987.87 23.03 1481.09 44.14 191.35 8.31 436.08 16.72 605.2-48.54 423.1-163.31 388.28-288.42 492.77-442.63z",
    style: {
      fill: "url(#id43)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7991.71 5082.02c-2.35 65.66-4.67 131.35-6.54 197.07-253.1 87.74-548.01 131.31-858.74 146.02-846.21 39.72-1667.86-130.9-2521.02-96.54-862 34.31-1689.66 160.26-2564.22 122.53-343.68-14.71-670.64-57.34-972.54-139.2-67.8-18.11-135.16-38.74-202.02-59.79-.93-30.4-2.37-60.3-4.19-90.67 380.85 96.53 729.65 183.81 1178.74 201.43 881.55 34.31 1742.64-141.65 2619.03-170.08 903.8-29.9 1815.99 193.63 2708.16 74.49 259.19-34.27 444-106.36 623.32-185.27z",
    style: {
      fill: "url(#id35)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6749.28 6346.6c-247.53 192.65-668.32 143.11-994.34 74.02-476.1-101.93-953.99-184.32-1451.9-234.79-529.9-53.45-1055.22-51.99-1589.8-55.85-453.28-2.95-859.68-41.16-1265.13-172.57-185.34-59.79-367.82-130.38-554.56-179.87-2.75-61.79-6.02-123.52-9.75-185.27 26.92 4.88 53.4 10.81 79.43 16.64 467.67 108.8 839.24 308.77 1349.68 347.55 447.27 33.32 902.42-1.47 1352.49 12.74 448.64 14.66 896.35 53.86 1332.43 122 219.7 34.83 436.61 75.53 650.7 122.58 215.52 47.5 474.23 131.83 708.25 96.57 431.97-65.22 170.01-322.54-90.05-398.07-183.95-53.39-385.96-84.27-583.84-108.8-882.42-110.25-1817.36-51.94-2713.28-90.66-720.37-30.88-1419.35-121.07-2093.28-274.48-1.39-28.91-2.76-57.86-4.63-86.76 999.5 196.55 2029.18 294.12 3081.64 260.28 482.04-15.23 963.23-25.47 1443.96 9.31 396.64 28.91 886.15 72.05 1206.61 233.29 235.48 118.62 350.66 332.84 145.36 492.12z",
    style: {
      fill: "url(#id3)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7797.92 6242.39c51.07 95.12 97.52 188.69 74.79 290.17-114.69 508.29-1434.23 330.34-2026.86 266.14-945.62-101.98-1886.1-225.45-2827.56-341.15-686.86-84.8-1445.75-149-2106.66-322h-.5c-1.38-29.93-2.8-59.83-4.19-89.72-.44-5.87-.44-11.79-.93-17.62 290.31 55.83 580.1 113.69 877.81 157.34 425.92 62.71 855.98 108.29 1288.4 150.45 934.91 90.7 1872.63 173.04 2804.3 275.46 410.57 45.12 1461.16 267.61 1737.94 5.87 220.15-207.83-166.28-435.72-7.4-657.79 66.37-93.11 205.71-169.05 362.75-219.57-1.87 50.95-3.75 101.47-5.14 151.47-81.74 31.82-151.9 61.75-172.32 76.94-126.32 90.23-44.11 181.84 5.58 274z",
    style: {
      fill: "url(#id47)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6674.53 9178.26c-220.16 225.44-643.27 234.75-975.39 211.24-485.29-34.31-969.73-49.52-1469.91-29.93-532.27 20.59-1051.96 95.08-1582.37 165.72-449.13 60.24-857.34 79.38-1276.31 5.36-97.09-17.17-194.15-36.76-291.21-55.38-3.25-65.7-6.05-130.36-8.82-194.61 381.78 57.35 728.22 155.84 1156.46 128.44 447.7-28.95 894.08-126.96 1341.79-175.48 446.32-48.05 894.98-71.6 1336.21-64.74 222.47 3.95 442.63 14.24 660.87 30.93 219.67 17.12 487.25 64.69 714.81-3 418.91-124.45 125.39-343.08-142.6-381.82-189-26.93-393.37-29.42-592.62-26.45-888.92 13.72-1807.59 201.43-2700.26 288.24-604.26 58.32-1198.76 73.03-1782.11 42.12-1.39-31.36-2.76-62.76-4.15-93.64 906.57 28.44 1825.26-25.94 2747.61-185.77 475.65-82.34 950.29-159.29 1431.48-191.62 396.63-26.5 887.53-52.46 1226.56 63.2 248.96 84.32 392 280.87 209.96 467.17z",
    style: {
      fill: "url(#id41)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7218.38 10311.47c-26.46 49.49-62.71 98.97-71.05 148.01-79.87 9.77-169.52 15.7-270.34 19.11-5.53-185.77 230.36-372.5 47.39-544.56-276.78-262.2-888.03-176.42-1298.57-131.35-932.14 102.46-1869.37 184.79-2804.78 275.46-431.94 42.2-862.48 87.74-1287.9 150.48-27.9 3.95-55.71 8.33-83.62 12.73 0-5.36.49-11.79 1.39-17.61v-1.46c12.57-104.43 137.03-57.35 219.7-126-6.51-1.45-11.6-2.91-18.14-4.89 375.27-51.93 755.23-90.66 1115.14-134.79 940.98-116.17 1881.94-239.22 2827.56-341.15 592.61-64.21 1583.3-102.48 1698.03 405.83 22.28 101.45-24.17 195.13-74.8 290.21z",
    style: {
      fill: "url(#id13)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7941.53 6591.65c-3.74 110.78-7 214.74-9.77 310.76-33.42 41.21-78.49 79.43-142.59 110.77-274.01 134.33-633.5 91.7-948.38 58.38-313.98-32.85-589.37-36.29-901.49-4.43-221.09 22.57-444.94 37.24-668.36 45.59-445.39 16.17-817.86-82.34-1203.79-210.74-414.81-137.75-828.16-222.07-1296.33-256.88-419.84-30.85-844.78-40.67-1262.35-83.81-172.78-17.62-382.69-40.7-579.61-80.4-1.88-32.81-3.27-66.14-5.13-98.98 47.83 11.74 96.59 22.55 145.85 31.33 229.42 40.23 466.29 62.75 703.16 79.43 394.31 27.92 791.39 36.75 1184.8 69.14 404.08 33.79 782.56 82.81 1159.7 180.84 432.87 112.76 856.46 271.55 1339.04 268.13 448.17-3.43 875.46-77.97 1324.59-30.88 255.91 27.45 527.59 76.42 782.16 17.63 262.87-60.78 308.81-201.95 359.01-352.91 6.02-18.14 12.49-35.76 19.48-52.97z",
    style: {
      fill: "url(#id11)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7906.7 7381.32c-3.73 21.57-8.36 43.62-13.94 65.19-5.13 20.11-10.2 39.72-16.23 59.31-208.12 10.81-469.15 12.77-799.35 9.77-421.72-37.22-840.16-96.02-1262.36-139.16-486.27-49.01-973.43-90.66-1467.63-97.51-400.82-5.41-802.09 3.89-1197.82-41.69-394.75-45.13-697.14-129.87-1045.45-246.04-105.43-34.82-213.16-69.6-323.26-101 14.4-8.84 20.9-30.4 6.02-44.6-173.22-168.59-512.3-86.76-747.26-189.22-3.73-1.46-7-3.43-10.7-5.87 563.39-42.63 1084.02 211.78 1567.49 376.46 198.31 67.12 399.48 135.28 627.48 160.26 238.3 26.47 482.13 30.93 724.57 31.87 425.42 1.46 844.77-.94 1268.38 29.41 882.45 63.21 1808.09 166.2 2690.08 132.83z",
    style: {
      fill: "url(#id44)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7825.4 9550.24c-3.7 50.98-7.43 98.03-11.13 141.19-8.38-1.98-17.21-3.95-25.55-6.4-261.47-69.6-647.44-154.39-762.18-337.22-145.37-231.36 253.63-435.73 46.01-656.32-261.04-278.43-876.43-229.88-1288.4-209.76-936.3 45.53-1877.27 71.06-2815.9 104.87-433.8 15.67-866.22 35.27-1294.89 71.55-211.79 18.14-419.37 43.62-626.51 70.12-1.39-38.76-2.85-77.44-4.23-115.71 607.55-94.59 1270.74-113.21 1879.14-150.95 946.58-58.36 1892.65-124.03 2842.45-168.63 595.43-28.42 1586.56-6.35 1671.07 507.82 16.71 102.93-34.82 193.62-91.52 285.74-54.82 88.68-142.11 174.98-21.35 273.02 48.77 39.72 141.17 72.58 209.95 97.56 95.21 35.27 193.19 65.66 293.03 93.11z",
    style: {
      fill: "url(#id38)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7883.49 8377.83c-4.19 108.79-8.38 214.15-12.57 315.12-18.1-37.74-32.05-77.93-43.19-120.05-41.81-153.91-79.42-298.06-338.11-374.51-250.82-73.99-524.82-41.66-781.66-29.91-451.01 20.12-873.18-80.37-1320.44-111.23-481.59-32.86-914.01 99.95-1352.01 186.25-382.67 74.99-763.08 101.47-1168.52 110.26-394.31 8.3-791.4-6.81-1187.13-2.91-216.41 2.43-433.8 8.83-646.07 30.4-1.39-30.4-2.26-61.29-3.65-91.7 136.98-12.22 272.13-18.61 390.56-23.54 419.4-17.13 843.89-.94 1265.17-6.81 469.05-5.94 886.59-65.19 1308.36-177.96 392.89-104.42 770.48-180.37 1214.5-136.76 222.02 21.58 444.49 50 664.16 86.29 309.75 50.47 584.74 63.7 900.1 50.01 243.83-10.8 514.58-25.51 747.29 37.73-28.34 23.04-58.08 44.09-90.13 63.18 116.57 14.74 210.4 9.34 289.34 17.19 83.62 48.55 131.01 105.89 163.51 166.67v.47c.49 3.93.49 7.84.49 11.8z",
    style: {
      fill: "url(#id40)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7817.52 7683.75c-15.78 41.69-33.44 81.81-53.41 120.59-851.78-73.03-1749.61-26.5-2604.6-14.24-424.53 5.88-843.45-20.58-1267.97-43.08-241.96-13.31-485.78-22.6-725.45-9.88-228.98 11.8-434.25 68.16-636.26 124.02-468.18 129.91-974.9 338.68-1504.82 294.07-1.42-41.16-3.25-82.76-4.67-124.46 355.75 5.88 697.65-76 1016.22-162.23 354.41-96.1 661.84-163.22 1058.47-185.32 397.61-23.02 797.49 9.31 1198.26 26.98 493.72 21.58 982.8 7.86 1471.38-13.21 423.6-19.17 845.28-53.94 1268.38-66.68 322.81 15.69 579.65 31.86 784.48 53.44z",
    style: {
      fill: "url(#id23)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7979.51 5448.86c-1.39 29.86-2.32 59.31-3.26 89.17-99.85 18.61-202.02 36.75-291.66 85.29-174.15 94.14-195.05 236.27-235.49 420.55-45.96 208.3-160.7 380.36-333.92 492.12-70.6 45.59-131.89-68.62-64.09-116.19 176.92-124.96 254.97-271.03 297.72-483.27 23.18-115.2 35.26-204.41 114.24-293.09 132.35-148.51 328.35-195.08 516.46-194.58z",
    style: {
      fill: "url(#id28)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8030.63 3925.92c-1.38 37.75-2.84 75.49-4.23 113.69-239.19 116.19-524.79 211.26-774.22 200.5-62.69-2.44-73.82-94.09-14.85-113.69 144.87-48.55 301.42-59.36 449.58-97.57 115.64-29.89 229.93-67.15 343.72-102.93z",
    style: {
      fill: "url(#id10)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7924.25 7123.71c-.94 39.19-2.33 76.46-3.26 111.24 0 6.86-.44 13.76-.9 20.58-97.09 38.74-202.95 49.49-308.9 49.02-210.8 0-410.57-11.74-621.41 6.4-72 5.83-73.86-100.02-15.78-123.04 159.76-63.74 333.01-34.32 500.22-21.58 159.76 12.26 302.8 6.39 450.04-42.62z",
    style: {
      fill: "url(#id52)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7857.37 8991.65v.52c-4.19 80.37-7.89 157.35-11.59 229.87-78.53-74.49-141.21-173.51-181.15-264.69-48.8-111.26-62.26-246.54-123.52-350.43-106.84-180.41-312.6-188.73-492.33-196.59-85-3.9-85.94-141.13 0-140.15 221.09 1.46 463.95 21.58 602.38 229.41 80.82 122.52 94.29 273.01 155.12 405.3 14.85 31.87 32.05 60.82 51.08 86.76z",
    style: {
      fill: "url(#id24)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7488.16 2074.11-27.91 663.7-1.86 41.16-119.34 2841.43-15.33 364.15-147.67 3517.82c0 199.51-192.75 363.21-429.17 363.21H2136.31c-236.43 0-429.12-163.7-429.12-363.21L1566.9 5880.64l-6.95-167.14-137.03-3433.03c0-179.39 154.19-468.1 357.63-523.94 22.73-6.4 46-9.83 69.67-9.83l4989.5-33.79 97.08-.52 46.9-.48 74.8-.52c236.9 0 429.65 163.22 429.65 362.7z",
    style: {
      fill: "url(#id0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7236.93 2286.01-136.99 3449.67-13.95 354.37-135.63 3422.27c0 194.05-177.41 353.37-394.76 353.37H2319.86c-217.39 0-394.75-159.32-394.75-353.37l-128.73-3523.27-6.02-162.67-128.16-3506.07c0-194.1 177.41-352.91 394.8-352.91l4785.17-34.31c217.35 0 394.76 158.81 394.76 352.91z",
    style: {
      fill: "url(#id34)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6533.23 3184.82c-16.27 388.67-639.52 527.41-1171.79 551.43-228.05 10.24-459.78-12.78-688.32-10.3-202.01 2.92-404.06 17.12-605.64 24.02-438.88 14.66-875.45 34.78-1315.31 38.21-346.92 2.5-691.98 2.5-1036.63-2.91l-3.7-101.94c397.56 10.25 795.57 14.71 1192.24 8.79 438.88-6.39 878.26-14.2 1314.83-41.65 445.39-27.96 867.11-101.45 1299.98-167.12 313.99-47.6 796.07-157.36 720.38-412.27-79.42-266.62-523.93-399.44-889-491.13-707.31-176.43-1447.16-227.43-2199.11-242.62-497.41 8.33-988.35-28.9-1487.64-48.5 4.64-44.12 18.1-85.29 38.55-123.04 420.79 24.02 844.83 63.21 1253.99 70.6 1177.84 21.06 2322.26-198.05 3503.35-123.56 251.68 16.22 503.89 38.26 756.13 58.37a313.159 313.159 0 0 1 21.31 106.36c-616.3-62.27-1202.9-138.74-1837.78-110.3-415.67 18.6-825.8 61.75-1236.87 100.99 408.76 35.26 811.89 98.99 1199.24 178.93 554.56 114.64 1189.94 317.09 1171.79 737.65z",
    style: {
      fill: "url(#id32)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4036.41 3099.04c-34.41 143.16-254.56 235.29-501.2 257.33-384.55 34.35-736.11-92.64-1084.46-158.34-255.46-48.04-508.56-78.39-759.82-92.11l-4.2-106.36c277.3 15.18 550.85 48.5 813.71 99.48 305.61 58.85 616.78 176.95 952.12 164.21 304.67-11.27 586.12-205.89 260.54-325.98-143.49-52.91-377.11-63.2-541.06-80.83-391.99-41.69-787.69-70.6-1186.19-86.81-102.2-4.36-204.82-7.33-307.48-9.77l-3.74-93.62c250.82 5.4 501.61 15.69 752.87 31.86 408.26 26 861.09 47.55 1248.41 126.43 218.32 44.6 393.41 136.29 360.47 274.51z",
    style: {
      fill: "url(#id8)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2042.98 7470.69c-17.21 81.4-87.77 146.12-185.35 191.19l-5.53-150.03c42.7-47 48.77-100.95-5.57-149.96l-4.63-130.38c133.72 50.99 223.86 130.89 201.08 239.18z",
    style: {
      fill: "url(#id42)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5446.45 3194.6c-182.09 176.51-577.33 247.58-884.33 297.06-938.16 151.44-1899.11 73.52-2855.87 34.31l-4.68-131.82c170.49 6.34 340.92 13.67 511.4 21.56 885.22 39.69 1849.38 87.71 2682.66-142.68 246.59-68.1 639.47-263.18 336.23-441.59-177.91-104.95-483.05-142.17-714.31-175.5-480.74-68.6-979.98-90.19-1471.38-106.36-460.24-15.69-918.2-13.71-1375.67-3.43l-4.68-124.5c477.93-10.29 957.25-3.43 1430.06 12.74 416.6 14.24 836.94 33.84 1248.91 79.39 332.52 36.79 765.88 82.84 1023.62 232.82 206.69 119.61 229.42 301.45 78.05 447.99z",
    style: {
      fill: "url(#id19)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7225.75 2569.19c-292.64-19.62-583.85-47.57-872.29-80.85 283.32 106.82 569.45 212.2 862.97 306.8l-5.57 140.68c-486.72-156.37-947.93-352.44-1419.81-522.02-96.14-34.78-28.79-120.07 72.89-107.35 457.96 59.31 909.86 124.97 1365.06 173.53l-3.26 89.21z",
    style: {
      fill: "url(#id53)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7206.67 3051.48-4.63 115.71c-96.59-11.8-185.79-10.81-245.25 19.6-117.47 60.29-104.49 221.55-149.07 306.81-222.03 419.6-1071.04 428.39-1653.42 465.65-1142.55 74.02-2284.15 114.22-3428.07 118.12l-4.2-119.1c1163.46-25.95 2325.96-93.62 3482.87-148 419.85-19.6 952.61-5.41 1270.29-207.83 219.18-139.72 130.03-367.09 350.18-497.48 103.1-61.28 240.13-68.15 381.3-53.48z",
    style: {
      fill: "url(#id6)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7191.84 3422.06-4.68 109.8c-60.85 20.07-115.19 48.51-158.34 87.73-85 77.93-107.29 176.92-184.41 257.33-315.81 331.85-1176.43 272.54-1698.48 293.6-851.35 35.25-1701.74 74.96-2553.07 103.91-285.16 9.31-571.72 21.58-858.26 32.85l-5.6-153.92c322.81-10.76 645.12-20.58 966.07-32.34 867.08-32.84 1735.6-55.87 2603.66-83.32 360.89-11.28 828.11 16.12 1158.82-91.18 307.47-99.03 290.27-337.69 550.81-462.23 58.97-28.44 120.3-48.97 183.48-62.23z",
    style: {
      fill: "url(#id16)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7172.3 3907.28-15.33 387.27c-8.34 5.4-17.61 10.76-26.93 16.17-143.49 79.9-323.26 135.26-507.62 167.64-270.79 47.51-567.57 51.46-846.26 59.74-336.27 10.81-675.76 17.71-1011.54 10.33-706.91-15.69-1417.03 33.33-2123.46 45.59-76.63.98-72.93-67.63 0-72.52 764.02-51.03 1525.71-85.81 2286.01-151.01 347.38-29.9 700.82-51.47 1051.04-64.71 270.3-10.29 595.88 6.39 856.42-47.52 293.03-61.28 266.6-208.81 337.65-350.98z",
    style: {
      fill: "url(#id31)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7143.02 4643.98-4.16 109.31c-185.34 23.55-391.54 16.69-563.82 21.58-781.68 23.54-1563.83 41.69-2346.88 54.89-391.05 6.87-782.11 12.26-1173.65 13.25-300.94 1.47-591.69 12.27-848.08-98.03-156.01-67.17-274.9-121.55-461.17-148.01l-3.23-90.23c12.04 2.5 24.13 6.4 35.71 9.86 241.55 74.97 414.32 208.78 689.26 245.02 329.76 43.65 714.31-9.26 1046.83-21.58 679.51-25 1360.84-46.07 2041.22-59.26 339.53-6.4 679.99-10.78 1019.97-16.69 177.88-2.91 377.09 5.92 551.75-17.11 5.12-.51 10.69-1.51 16.22-3z",
    style: {
      fill: "url(#id4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7129.56 4983.16-6.03 152.46c-83.12 0-165.77-3.43-244.76-7.37-466.3-23.97-927.97-39.72-1396.58-33.28-489.07 6.81-975.34 23.96-1461.12 59.31-426.41 31.34-865.73 63.16-1293.96 29.89-366.47-27.93-652.1-135.31-969.33-241.67l-1.39-42.63c211.33 69.09 421.23 134.29 629.36 159.8 520.19 62.74 1021.29-17.67 1534.49-59.84 500.22-41.16 1007.39-65.14 1511.75-66.17 495.14-.95 987.92 23.02 1481.14 44.09 67.35 3 141.22 5.9 216.42 5.4z",
    style: {
      fill: "url(#id26)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7117.52 5292.45-5.57 133.34c-841.12 37.27-1658.09-131.35-2506.62-97.05-862 34.31-1689.66 160.26-2564.22 122.53-89.64-3.9-177.85-9.79-265.17-17.62l-3.31-90.67c85.98 9.82 175.12 16.64 268.48 20.07 881.51 34.36 1742.61-141.65 2619.03-170.09 819.25-26.93 1645.52 153.92 2457.38 99.49z",
    style: {
      fill: "url(#id2)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6749.2 6346.77c-247.53 192.65-668.36 143.15-994.38 74.02-476.02-101.94-953.95-184.29-1451.86-234.8-529.94-53.39-1055.22-51.93-1589.8-55.83-323.26-1.98-622.36-22.05-914.5-81.36l-2.32-59.78-4.65-128.49c162.58 45.63 332.54 81.91 521.14 96.11 447.27 33.33 902.38-1.5 1352.44 12.78 448.65 14.67 896.4 53.86 1332.48 122.02 219.7 34.82 436.61 75.48 650.7 122.56 215.48 47.52 474.23 131.84 708.25 96.54 431.97-65.19 170.01-322.54-90.05-398.02-183.95-53.44-386.01-84.27-583.84-108.81-882.45-110.26-1817.36-51.98-2713.28-90.67-402.7-17.15-798.42-52.91-1187.12-107.85l-4.19-104.4c712.47 94.09 1437.93 134.8 2174.99 111.25 482.07-15.18 963.26-25.47 1443.95 9.31 396.68 28.94 886.19 72.08 1206.64 233.34 235.49 118.57 350.67 332.79 145.37 492.07z",
    style: {
      fill: "url(#id56)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7059.89 6742.36-5.09 137.23c-422.17 13.27-908.92-48.54-1208.96-80.88-945.62-101.98-1886.1-225.45-2827.56-341.15-390.56-48.05-804.4-89.69-1210.3-148.52l-4.2-120.55c419.42 61.29 842.99 105.88 1268.43 147.53 934.91 90.7 1872.63 173.04 2804.3 275.46 258.67 28.43 770.03 127.45 1183.37 130.89z",
    style: {
      fill: "url(#id14)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6674.45 9178.42c-220.16 225.46-643.27 234.76-975.35 211.22-485.33-34.28-969.77-49.48-1469.98-29.9-532.23 20.63-1051.93 95.14-1582.34 165.68-248.06 33.35-483.49 53.9-714.84 53.47-4.63-21.58-6.92-44.19-6.92-66.69l-3.74-102.96c98.03 5.92 199.25 6.9 305.62 0 447.7-28.87 894.08-126.9 1341.79-175.42 446.32-48.03 895.02-71.57 1336.18-64.71 222.51 3.9 442.61 14.2 660.9 30.88 219.71 17.15 487.25 64.67 714.81-2.95 418.91-124.5 125.39-343.14-142.56-381.82-189.08-26.98-393.41-29.42-592.66-26.46-888.96 13.72-1807.59 201.44-2700.26 288.15-313.99 30.41-625.62 48.55-934.03 55.42l-3.73-104.9c629.35-17.62 1263.33-77.89 1899.11-187.71 475.62-82.33 950.28-159.31 1431.48-191.66 396.62-26.46 887.53-52.42 1226.56 63.25 248.96 84.32 392 280.87 209.96 467.12z",
    style: {
      fill: "url(#id54)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7049.23 7010.95-3.25 81.35c-69.68-5.87-138.41-13.72-205.28-20.55-313.98-32.88-589.37-36.28-901.49-4.45-221.09 22.55-444.98 37.26-668.36 45.62-445.39 16.17-817.86-82.39-1203.83-210.78-414.77-137.71-828.12-222.02-1296.29-256.85-316.3-23.02-635.82-34.78-952.57-57.38l-3.25-92.12c380.36 25.52 763.08 34.78 1142.51 66.18 404.11 33.83 782.64 82.85 1159.74 180.9 432.92 112.7 856.46 271.5 1339.04 268.08 448.17-3.43 875.46-77.93 1324.55-30.88 88.26 9.31 177.91 21.58 268.47 30.88z",
    style: {
      fill: "url(#id29)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7034.83 7376.6-5.12 134.83c-405.9-37.31-808.6-93.14-1214.98-134.83-486.27-49.01-973.48-90.67-1467.68-97.52-400.77-5.41-802.04 3.9-1197.77-41.68-394.8-45.09-697.11-129.86-1045.45-246.04-89.66-29.42-181.16-59.31-274.01-86.76l-5.61-148.98c267.54 79.38 524.83 187.24 771.94 271.55 198.32 67.12 399.39 135.26 627.44 160.26 238.3 26.45 482.13 30.88 724.57 31.82 425.42 1.46 844.78-.94 1268.38 29.46 595.43 42.63 1210.34 103.41 1818.29 127.89z",
    style: {
      fill: "url(#id30)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6994.41 8396.09-8.83 222.59c-293.03-196.08-829.94-154.91-1201.51-136.82-936.3 45.63-1877.27 71.11-2815.94 104.96-359.45 13.2-718.47 28.89-1074.7 54.38l-4.64-119.09c348.8-24.5 698.99-39.73 1032.9-60.26 946.55-58.38 1892.65-124.03 2842.4-168.64 361.38-17.15 869-15.69 1230.32 102.89z",
    style: {
      fill: "url(#id22)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7007.43 8072.12-3.27 81.35c-99.84 3.43-199.24 10.81-296.33 15.24-450.97 20.07-873.14-80.37-1320.4-111.3-481.59-32.84-914.01 100.02-1352.01 186.31-382.68 74.96-763.08 101.42-1168.52 110.25-326.96 6.87-655.79-2.49-984.14-2.91l-3.73-93.14c268.91 0 538.29 5.41 806.76 1.46 469.05-5.88 886.59-65.23 1308.32-177.9 392.93-104.42 770.52-180.42 1214.54-136.8 221.98 21.57 444.49 50.01 664.16 86.28 309.75 50.53 584.74 63.74 900.09 50 76.14-3.42 155.09-7.37 234.53-8.83z",
    style: {
      fill: "url(#id21)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7025.07 7631-5.58 136.76c-620.03-12.25-1251.17 13.66-1860.11 22.52-424.47 5.85-843.4-20.6-1267.92-43.11-241.96-13.25-485.78-22.56-725.45-9.81-228.98 11.79-434.25 68.15-636.27 124.02-211.78 58.79-431.94 133.8-658.14 194.57l-5.13-142.65c57.59-14.69 114.3-29.4 170.01-44.59 354.36-96.05 661.84-163.21 1058.47-185.27 397.57-23.07 797.49 9.31 1198.26 26.93 493.72 21.58 982.75 7.86 1471.38-13.21 420.78-19.12 840.19-53.44 1260.49-66.17z",
    style: {
      fill: "url(#id39)"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "fil3",
    d: "M8294.51 205.68c-453.28 338.34-925.48 586.48-1468.41 722.34-45.55 11.35-26.19 86.55 19.4 74.2 529.7-143.15 1045.74-400.39 1465.47-774.02 11.68-10.37-3.81-31.98-16.46-22.52z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrameBg);
export default __webpack_public_path__ + "static/media/frame_bg.71e9a1c5ced87a63e1ee37bd3a2a64c9.svg";
export { ForwardRef as ReactComponent };